import React from "react";
import { Handle, Position } from "react-flow-renderer";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";
import { Forward } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  nodeContainer: {
    minWidth: 200,
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    background: "linear-gradient(135deg, #00bcd4 0%, #26c6da 100%)",
    boxShadow: "0 4px 12px rgba(0, 188, 212, 0.4)",
    border: "2px solid #00bcd4",
    color: "white",
    position: "relative",
    transition: "all 0.2s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 16px rgba(0, 188, 212, 0.5)",
    },
  },
  nodeHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  nodeIcon: {
    fontSize: 20,
  },
  nodeLabel: {
    fontWeight: 600,
    fontSize: 14,
    color: "white",
  },
  nodeContent: {
    fontSize: 12,
    opacity: 0.95,
    marginTop: theme.spacing(0.5),
    padding: theme.spacing(1),
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    borderRadius: 8,
  },
  handle: {
    width: 12,
    height: 12,
    background: "white",
    border: "2px solid #00bcd4",
    borderRadius: "50%",
  },
}));

const TransferQueueNode = ({ data, selected }) => {
  const classes = useStyles();
  const queueName = data?.queueName || (data?.queueId ? "Departamento seleccionado" : "Sin departamento");

  return (
    <Box
      className={classes.nodeContainer}
      style={{
        boxShadow: selected
          ? "0 6px 20px rgba(0, 188, 212, 0.6)"
          : "0 4px 12px rgba(0, 188, 212, 0.4)",
      }}
    >
      <Handle
        type="target"
        position={Position.Top}
        className={classes.handle}
        style={{ top: -6 }}
      />
      <Box className={classes.nodeHeader}>
        <Forward className={classes.nodeIcon} />
        <Typography className={classes.nodeLabel}>Transferir a departamento</Typography>
      </Box>
      <Box className={classes.nodeContent}>
        {queueName && queueName !== "Sin departamento" ? queueName : "Sin departamento configurado"}
      </Box>
      <Handle
        type="source"
        position={Position.Bottom}
        className={classes.handle}
        style={{ bottom: -6 }}
      />
    </Box>
  );
};

export default TransferQueueNode;
